<div #step5 class="ui-g">
  <div class="ui-g-12">
    <div class="card left">

      <div class="ui-g-12">
        <div class="subtitle">
          <div class="campaign-sub">{{ 'campaign.confirmCouponList' | translate }}</div>
        </div>
      </div>

      <div class="ui-g-12" *ngFor="let coupon of generatedCoupons.coupons; let i = index;">
        <p-table #couponTables data-testid="couponTables" [value]="coupon.couponList" emptyMessage="No coupons generated" [paginator]="true" [rows]="10">
            <ng-template pTemplate="header">
                <tr>
                    <th colspan="16" style="text-align: center; padding: .5em .75em; -webkit-box-sizing: border-box; box-sizing: border-box; background: #20417b; color: #FFFFFF; border-radius: 0; border: none; font-size: 16px; height: auto;">
                        Type: {{ coupon.name }}
                    </th>
                </tr>
                <tr>
                    <th colspan="8" style="padding-top: 10px; padding-bottom: 10px; font-size: 20px; background-color:rgba(102, 127, 161, 0.863)">Coupon</th>
                    <th colspan="7" style="padding-top: 10px; padding-bottom: 10px; font-size: 20px; background-color:rgba(136, 221, 119, 0.774)">{{ 'campaign.channel' | translate }}</th>
                    <th colspan="1" style="padding-top: 10px; padding-bottom: 10px; font-size: 20px; background-color:rgba(224, 255, 49, 0.87)">Action</th>
                </tr>
                <tr>
                    <th>{{ 'campaign.category' | translate }}</th>
                    <th>{{ 'campaign.customers' | translate }}</th>
                    <th>{{ 'campaign.discountType' | translate }}</th>
                    <th>{{ 'campaign.discount' | translate }}</th>
                    <th>{{ 'campaign.threshold' | translate }}</th>
                    <th>{{ 'campaign.validityStartDate' | translate }}</th>
                    <th>{{ 'campaign.validityEndDate' | translate }}</th>
                    <th>{{ 'campaign.channel' | translate }}</th>
                    <th>{{ 'campaign.shortDescription' | translate }}</th>
                    <th>{{ 'campaign.completeDescription' | translate }}</th>
                    <th>{{ 'campaign.emissionStartDate' | translate }}</th>
                    <th>{{ 'campaign.emissionEndDate' | translate }}e</th>
                    <th>{{ 'campaign.templateCode' | translate }}</th>
                    <th>{{ 'campaign.bmpCode' | translate }}</th>
                    <th>{{ 'campaign.layoutCode' | translate }}</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td>
                        <div *ngIf="!row.isEditable" class="not-editable">{{row.categoria}}</div>
                        <div *ngIf="row.isEditable && coupon.type_code == 2">
                            <p-dropdown
                            [filter]="true"
                            [options]="categories"
                            [placeholder]="row.categoria"
                            [(ngModel)]="row.categoria"
                            [style]="{ maxWidth: '100%' }"></p-dropdown>
                        </div>
                        <div *ngIf="row.isEditable && coupon.type_code != 2" >
                            <input
                            readonly
                            type="text"
                            [value]="row.categoria">
                        </div>
                    </td>
                    <td>
                        <div *ngIf="!row.isEditable" class="not-editable">{{row.clienti}}</div>
                        <div *ngIf="row.isEditable">
                            <p-multiSelect
                            defaultLabel="Clienti"
                            [style]="{ width: '100%' }"
                            [options]="segmentOptions"
                            [(ngModel)]="row.clienti"></p-multiSelect>
                        </div>
                    </td>
                    <td>
                        <div *ngIf="!row.isEditable" class="not-editable">{{row.tipo_sconto}}</div>
                        <div *ngIf="row.isEditable">
                            <p-dropdown
                            [filter]="true"
                            [options]="discountTypes"
                            [placeholder]="row.tipo_sconto"
                            [(ngModel)]="row.tipo_sconto"
                            [style]="{ maxWidth: '100%' }"></p-dropdown>
                        </div>
                    </td>
                    <td>
                        <div *ngIf="!row.isEditable" class="not-editable">{{row.sconto}}</div>
                        <div *ngIf="row.isEditable">
                            <input type="text" [(ngModel)]="row.sconto">
                        </div>
                    </td>
                    <td>
                        <div *ngIf="!row.isEditable" class="not-editable">{{row.soglia}}</div>
                        <div *ngIf="row.isEditable">
                            <input type="text" [(ngModel)]="row.soglia">
                        </div>
                    </td>
                    <td>
                        <div *ngIf="!row.isEditable" class="not-editable">{{row.data_inizio_validita}}</div>
                        <div *ngIf="row.isEditable">
                            <p-calendar
                            dateFormat="dd/mm/yy"
                            dataType="string"
                            [(ngModel)]="row.data_inizio_validita"
                            [monthNavigator]="true"
                            [yearNavigator]="true"
                            [yearRange]="'1900:2099'"
                            [maxDate]="maxDate"
                            [placeholder]="row.data_inizio_validita">
                            </p-calendar>
                        </div>
                    </td>
                    <td>
                        <div *ngIf="!row.isEditable" class="not-editable">{{row.data_fine_validita}}</div>
                        <div *ngIf="row.isEditable">
                            <p-calendar
                            dateFormat="dd/mm/yy"
                            dataType="string"
                            [(ngModel)]="row.data_fine_validita"
                            [monthNavigator]="true"
                            [yearNavigator]="true"
                            [yearRange]="'1900:2099'"
                            [maxDate]="maxDate"
                            [placeholder]="row.data_fine_validita">
                            </p-calendar>
                        </div>
                    </td>
                    <td>
                        <div *ngIf="!row.isEditable" class="not-editable">{{row.canale}}</div>
                        <div *ngIf="row.isEditable">
                            <p-dropdown
                            [options]="channelsOptions"
                            [placeholder]="row.canale"
                            [(ngModel)]="row.canale"
                            [style]="{'max-width':'100%'}"></p-dropdown>
                        </div>
                    </td>
                    <td>
                        <div *ngIf="!row.isEditable" class="not-editable">{{row.descrizione_breve}}</div>
                        <div *ngIf="row.isEditable">
                            <textarea
                            style="max-width: 100%; resize: none;"
                            [(ngModel)]="row.descrizione_breve"
                            (click)="showShortDescDialog=true"
                            maxlength="200">
                            </textarea>
                            <p-dialog
                            header="Descrizione breve"
                            [(visible)]="showShortDescDialog"
                            [modal]="true"
                            [blockScroll]="true"
                            [dismissableMask]="true"
                            [closable]="false">
                                <textarea
                                [(ngModel)]="row.descrizione_breve"
                                rows="6"
                                cols="50"
                                maxlength="200">
                                </textarea>
                                <p-footer>
                                    <button
                                    type="button"
                                    pButton
                                    icon="pi pi-check"
                                    (click)="showShortDescDialog=false"
                                    label="OK"></button>
                                </p-footer>
                            </p-dialog>
                        </div>
                    </td>
                    <td>
                        <div *ngIf="!row.isEditable" class="not-editable">{{row.descrizione_completa}}</div>
                        <div *ngIf="row.isEditable">
                            <textarea
                            style="max-width: 100%; resize: none;"
                            [(ngModel)]="row.descrizione_completa"
                            (click)="showCompleteDescDialog=true"
                            maxlength="1024">
                            </textarea>
                            <p-dialog
                            header="Descrizione completa"
                            [(visible)]="showCompleteDescDialog"
                            [modal]="true"
                            [blockScroll]="true"
                            [dismissableMask]="true"
                            [closable]="false">
                                <textarea
                                [(ngModel)]="row.descrizione_completa"
                                rows="6"
                                cols="50"
                                maxlength="1024">
                                </textarea>
                                <p-footer>
                                    <button
                                    type="button"
                                    pButton
                                    icon="pi pi-check"
                                    (click)="showCompleteDescDialog=false"
                                    label="OK"></button>
                                </p-footer>
                            </p-dialog>
                        </div>
                    </td>
                    <td>
                        <div *ngIf="!row.isEditable" class="not-editable">{{row.data_inizio_emissione}}</div>
                        <div *ngIf="row.isEditable">
                            <p-calendar
                            dateFormat="dd/mm/yy"
                            dataType="string"
                            [(ngModel)]="row.data_inizio_emissione"
                            [monthNavigator]="true"
                            [yearNavigator]="true"
                            [yearRange]="'1900:2099'"
                            [maxDate]="maxDate"
                            [placeholder]="row.data_inizio_emissione">
                            </p-calendar>
                        </div>
                    </td>
                    <td>
                        <div *ngIf="!row.isEditable" class="not-editable">{{row.data_fine_emissione}}</div>
                        <div *ngIf="row.isEditable">
                            <p-calendar
                            dateFormat="dd/mm/yy"
                            dataType="string"
                            [(ngModel)]="row.data_fine_emissione"
                            [monthNavigator]="true"
                            [yearNavigator]="true"
                            [yearRange]="'1900:2099'"
                            [maxDate]="maxDate"
                            [placeholder]="row.data_fine_emissione">
                            </p-calendar>
                        </div>
                    </td>
                    <td>
                        <div *ngIf="!row.isEditable" class="not-editable">{{row.codice_template}}</div>
                        <div *ngIf="row.isEditable">
                            <input type="text" [(ngModel)]="row.codice_template">
                        </div>
                    </td>
                    <td>
                        <div *ngIf="!row.isEditable" class="not-editable">{{row.codice_bmp}}</div>
                        <div *ngIf="row.isEditable">
                            <input type="text" [(ngModel)]="row.codice_bmp">
                        </div>
                    </td>
                    <td>
                        <div *ngIf="!row.isEditable" class="not-editable">{{row.codice_layout}}</div>
                        <div *ngIf="row.isEditable">
                            <input type="text" [(ngModel)]="row.codice_layout">
                        </div>
                    </td>
                    <td style="display: flex; justify-content: space-around;">
                      <button [disabled]="editingMode" *ngIf="!row.isEditable" (click)="editRow(row, coupon.type_code)"><i class="fa fa-edit"></i></button>
                      <button *ngIf="row.isEditable" (click)="saveRow(row)"><i class="fa fa-save"></i></button>
                      <button [disabled]="row.isEditable || editingMode" (click)="deleteRow(row)"><i class="fa fa-trash"></i></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <button *ngIf="(coupon.flag_tipo_attivo && coupon.codice_tipo == 1) || (coupon.flag_tipo_attivo && coupon.codice_tipo == 2)" [disabled]="editingMode" class="Coupon-preview add-coupon-btn" (click)="addRow(coupon.couponList, coupon.codice_tipo, i)">
           <i class="fa fa-plus"></i> {{ 'campaign.addCoupon' | translate }}
        </button>
      </div>

    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-5/campaign-step-5.html